
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"#5D5D67","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.502 6.132H8.994v5.943L13.77 14.9l.754-1.219-4.023-2.348v-5.2zM15.367 0L20 3.809l-1.287 1.52-4.637-3.806L15.366 0zM4.632 0l1.29 1.522-4.635 3.807L0 3.808 4.632 0zM10 2.17C5.001 2.17.95 6.16.95 11.084.948 16.008 5 20 9.998 20c4.999 0 9.052-3.992 9.052-8.915 0-4.924-4.053-8.916-9.051-8.916zm0 15.849c-3.881 0-7.04-3.11-7.04-6.934C2.96 7.26 6.119 4.15 10 4.15c3.882 0 7.04 3.11 7.04 6.934 0 3.823-3.158 6.934-7.04 6.934z"}})])
          )
        }
      }
    